import React, { useState } from "react";
import { capitalApi } from "../../lib/api";
import { STAGES } from "./Scoreboard";
import { INTEREST } from "./LeadModal";
import { ChevronDown, ChevronRight, Mail, Trash2, Pencil } from "lucide-react";
import { Avatar } from "../team/TeamChips";
import { SiteLink } from "../shared";

const fmtIn = (n) => (n ? Math.round(n).toLocaleString("en-US") : "");
const parseNum = (s) => +String(s).replace(/[^\d]/g, "") || 0;
const dueTone = (d, today) => (!d ? "" : d < today ? "neg" : d === today ? "neu" : "");
const SEL = { width: 118, padding: "4px 6px", fontSize: 11 };
const NUM = { width: 92, padding: "4px 6px", fontSize: 11, textAlign: "right" };

const MoneyCell = ({ value, onCommit, testid }) => {
  const [draft, setDraft] = useState(null);
  const shown = draft === null ? fmtIn(value) : draft;
  const commit = () => { if (draft !== null) { const n = parseNum(draft); setDraft(null); if (n !== (value || 0)) onCommit(n); } };
  return (
    <input className="inp mono" style={NUM} value={shown} onChange={(e) => setDraft(e.target.value)} onBlur={commit}
      onKeyDown={(e) => e.key === "Enter" && e.target.blur()} inputMode="numeric" data-testid={testid} />
  );
};

export const LeadRow = ({ lead, today, checked, expanded, onCheck, onExpand, onChange, onEdit, onRemove, onMail }) => {
  const patch = async (p) => onChange(await capitalApi.patch(lead.id, p));
  const hot = (lead.interest || "").toLowerCase() === "hot";
  return (
    <tr className={`cm-lead-row ${hot ? "hot" : ""} ${lead.inCampaign ? "in-campaign" : ""}`} data-testid={`lead-row-${lead.id}`} data-hot={hot ? "1" : "0"} data-incampaign={lead.inCampaign ? "1" : "0"}>
      <td><input type="checkbox" checked={checked} onChange={onCheck} data-testid={`lead-check-${lead.id}`} /></td>
      <td>
        <button className="btn" style={{ padding: "1px 4px", marginRight: 5 }} onClick={() => onExpand(lead.id)} data-testid={`lead-expand-${lead.id}`}>
          {expanded ? <ChevronDown size={12} /> : <ChevronRight size={12} />}
        </button>
        {lead.inCampaign && <span className="lead-name-dot campaign" title={`In campaign${lead.campaignName ? `: ${lead.campaignName}` : ""}`} data-testid={`lead-campaign-dot-${lead.id}`} />}
        {hot && <span className="lead-name-dot" title="Hot lead" />}
        {lead.name}
        {lead.classPref ? <span className="tag" style={{ marginLeft: 6, fontSize: 9 }}>Class {lead.classPref}</span> : null}
        {lead.owner ? <span className="lead-owner" data-testid={`lead-owner-${lead.id}`}><Avatar name={lead.owner} email={lead.owner} size={18} title={`Owner: ${lead.owner}`} /></span> : null}
      </td>
      <td style={{ color: "var(--text2)" }}>{lead.email || "—"}</td>
      <td>{lead.firm ? <>{lead.firm}<SiteLink url={lead.website} name={lead.firm} testid={`lead-site-${lead.id}`} /></> : "—"}</td>
      <td><span className="tag">{lead.type || "—"}</span></td>
      <td>
        <select className="inp" style={SEL} value={lead.stage} onChange={(e) => patch({ stage: e.target.value })} data-testid={`lead-stage-${lead.id}`}>
          {STAGES.map((s) => <option key={s}>{s}</option>)}
        </select>
      </td>
      <td>
        <select className={`inp int-${(lead.interest || "").toLowerCase()}`} style={{ ...SEL, width: 92 }} value={lead.interest || "Warm"} onChange={(e) => patch({ interest: e.target.value })} data-testid={`lead-interest-${lead.id}`}>
          {INTEREST.map((s) => <option key={s}>{s}</option>)}
        </select>
      </td>
      <td className="num"><MoneyCell value={lead.indicated} onCommit={(n) => patch({ indicated: n })} testid={`lead-indicated-${lead.id}`} /></td>
      <td className="num"><MoneyCell value={lead.committed} onCommit={(n) => patch({ committed: n })} testid={`lead-committed-${lead.id}`} /></td>
      <td>
        <input type="date" className={`inp ${dueTone(lead.nextFollowUp, today)}`} style={{ ...SEL, width: 126 }} value={lead.nextFollowUp || ""} onChange={(e) => patch({ nextFollowUp: e.target.value })} data-testid={`lead-followup-${lead.id}`} />
      </td>
      <td style={{ color: "var(--text3)", fontSize: 11 }}>{lead.lastContact || "—"}</td>
      <td style={{ color: "var(--text3)", fontSize: 11 }}>{lead.source || "—"}</td>
      <td><button className="btn" style={{ padding: "3px 7px" }} onClick={() => onMail(lead.id)} disabled={!lead.email} title="AI follow-up email" data-testid={`lead-mail-${lead.id}`}><Mail size={13} /></button></td>
      <td><button className="btn" style={{ padding: "3px 7px" }} onClick={() => onEdit(lead)} title="Edit LP" data-testid={`lead-edit-${lead.id}`}><Pencil size={13} /></button></td>
      <td><button className="btn" style={{ padding: "3px 6px" }} onClick={() => onRemove(lead)} title="Remove" data-testid={`lead-remove-${lead.id}`}><Trash2 size={13} /></button></td>
    </tr>
  );
};
